import { createReducer, createAction } from "redux-act";
import * as app from "./app";

import { pendingTask, begin, end } from "react-redux-spinner";
import merge from "lodash/merge";
import {
  IMPORT_FORM_SUCCESS_ACTION,
  IMPORT_FORM_REQUEST_ACTION,
  IMPORT_FORM_FAILURE_ACTION
} from "./import";

export const REDUCER = "patient";

export const NS = `@@${REDUCER}/`;

/*********************************/
/*  SAVE_PROFILE_FORM_REQUEST    */
/*********************************/
const SAVE_PROFILE_FORM_REQUEST = `${app.NS}patient/save_profile_form_request`;
export const SAVE_PROFILE_FORM_REQUEST_ACTION = createAction(
  SAVE_PROFILE_FORM_REQUEST
);
const SAVE_PROFILE_FORM_SUCCESS = `${app.NS}patient/save_profile_form_success`;
export const SAVE_PROFILE_FORM_SUCCESS_ACTION = createAction(
  SAVE_PROFILE_FORM_SUCCESS
);
const SAVE_PROFILE_FORM_FAILURE = `${app.NS}patient/save_profile_form_failure`;
export const SAVE_PROFILE_FORM_FAILURE_ACTION = createAction(
  SAVE_PROFILE_FORM_FAILURE
);

export const saveProfileFormRequest = id => {
  const action = SAVE_PROFILE_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveProfileFormSuccess = program => {
  const action = SAVE_PROFILE_FORM_SUCCESS_ACTION(program);
  return action;
};

export const saveProfileFormFailure = error => {
  const action = SAVE_PROFILE_FORM_FAILURE_ACTION(error);
  return action;
};

/*********************************/
/*     LOAD_PATIENT_REQUEST      */
/*********************************/
const LOAD_PATIENT_REQUEST = `${NS}load_patient_request`;
export const LOAD_PATIENT_REQUEST_ACTION = createAction(LOAD_PATIENT_REQUEST);
const LOAD_PATIENT_SUCCESS = `${NS}load_patient_success`;
export const LOAD_PATIENT_SUCCESS_ACTION = createAction(
  LOAD_PATIENT_SUCCESS,
  patient => ({
    patient
  })
);
const LOAD_PATIENT_FAILURE = `${NS}load_patient_failure`;
export const LOAD_PATIENT_FAILURE_ACTION = createAction(LOAD_PATIENT_FAILURE);

export const loadPatientRequest = id => {
  const action = LOAD_PATIENT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadPatientSuccess = patient => {
  const action = LOAD_PATIENT_SUCCESS_ACTION(patient);
  action[pendingTask] = end;
  return action;
};
export const loadPatientFailure = error => {
  const action = LOAD_PATIENT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_GUEST_PERMISSION_REQUEST  */
/*********************************/
const DELETE_GUEST_PERMISSION_REQUEST = `${
  app.NS
}delete_guestPermission_request`;
export const DELETE_GUEST_PERMISSION_REQUEST_ACTION = createAction(
  DELETE_GUEST_PERMISSION_REQUEST
);
const DELETE_GUEST_PERMISSION_SUCCESS = `${
  app.NS
}delete_guestPermission_success`;

export const DELETE_GUEST_PERMISSION_SUCCESS_ACTION = createAction(
  DELETE_GUEST_PERMISSION_SUCCESS,
  guestPermission => ({
    guestPermission
  })
);
const DELETE_GUEST_PERMISSION_FAILURE = `${
  app.NS
}delete_guestPermission_failure`;
export const DELETE_GUEST_PERMISSION_FAILURE_ACTION = createAction(
  DELETE_GUEST_PERMISSION_FAILURE
);

export const deleteGuestPermissionRequest = id => {
  const action = DELETE_GUEST_PERMISSION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteGuestPermissionSuccess = user => {
  const action = DELETE_GUEST_PERMISSION_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteGuestPermissionFailure = error => {
  const action = DELETE_GUEST_PERMISSION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     SAVE_PATIENT_REQUEST      */
/*********************************/
const SAVE_PATIENT_REQUEST = `${NS}save_patient_request`;
export const SAVE_PATIENT_REQUEST_ACTION = createAction(SAVE_PATIENT_REQUEST);
const SAVE_PATIENT_SUCCESS = `${NS}save_patient_success`;
export const SAVE_PATIENT_SUCCESS_ACTION = createAction(
  SAVE_PATIENT_SUCCESS,
  patients => ({
    patients
  })
);
const SAVE_PATIENT_FAILURE = `${NS}save_patient_failure`;
export const SAVE_PATIENT_FAILURE_ACTION = createAction(SAVE_PATIENT_FAILURE);

export const savePatientRequest = id => {
  const action = SAVE_PATIENT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const savePatientSuccess = user => {
  const action = SAVE_PATIENT_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const savePatientFailure = error => {
  const action = SAVE_PATIENT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_PATIENT_REQUEST  */
/*********************************/
const DELETE_PATIENT_REQUEST = `${app.NS}delete_patient_request`;
export const DELETE_PATIENT_REQUEST_ACTION = createAction(
  DELETE_PATIENT_REQUEST
);
const DELETE_PATIENT_SUCCESS = `${app.NS}delete_patient_success`;

export const DELETE_PATIENT_SUCCESS_ACTION = createAction(
  DELETE_PATIENT_SUCCESS,
  patient => ({
    patient
  })
);
const DELETE_PATIENT_FAILURE = `${app.NS}delete_patient_failure`;
export const DELETE_PATIENT_FAILURE_ACTION = createAction(
  DELETE_PATIENT_FAILURE
);

export const deletePatientRequest = id => {
  const action = DELETE_PATIENT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deletePatientSuccess = user => {
  const action = DELETE_PATIENT_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deletePatientFailure = error => {
  const action = DELETE_PATIENT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_SUPPORT_USER_REQUEST  */
/*********************************/
const DELETE_SUPPORT_USER_REQUEST = `${app.NS}delete_supportUser_request`;
export const DELETE_SUPPORT_USER_REQUEST_ACTION = createAction(
  DELETE_SUPPORT_USER_REQUEST
);
const DELETE_SUPPORT_USER_SUCCESS = `${app.NS}delete_supportUser_success`;

export const DELETE_SUPPORT_USER_SUCCESS_ACTION = createAction(
  DELETE_SUPPORT_USER_SUCCESS,
  supportUser => ({
    supportUser
  })
);
const DELETE_SUPPORT_USER_FAILURE = `${app.NS}delete_supportUser_failure`;
export const DELETE_SUPPORT_USER_FAILURE_ACTION = createAction(
  DELETE_SUPPORT_USER_FAILURE
);

export const deleteSupportUserRequest = id => {
  const action = DELETE_SUPPORT_USER_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteSupportUserSuccess = user => {
  const action = DELETE_SUPPORT_USER_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteSupportUserFailure = error => {
  const action = DELETE_SUPPORT_USER_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SAVE_PATIENT_CONDITION_REQUEST  */
/*********************************/
const SAVE_PATIENT_CONDITION_REQUEST = `${
  app.NS
}save_patient_condition_request`;
export const SAVE_PATIENT_CONDITION_REQUEST_ACTION = createAction(
  SAVE_PATIENT_CONDITION_REQUEST
);
const SAVE_PATIENT_CONDITION_SUCCESS = `${
  app.NS
}save_patient_condition_success`;

export const SAVE_PATIENT_CONDITION_SUCCESS_ACTION = createAction(
  SAVE_PATIENT_CONDITION_SUCCESS,
  patientCondition => ({
    patientCondition
  })
);
const SAVE_PATIENT_CONDITION_FAILURE = `${NS}save_user_failure`;
export const SAVE_PATIENT_CONDITION_FAILURE_ACTION = createAction(
  SAVE_PATIENT_CONDITION_FAILURE
);

export const savePatientConditionRequest = id => {
  const action = SAVE_PATIENT_CONDITION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const savePatientConditionSuccess = user => {
  const action = SAVE_PATIENT_CONDITION_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const savePatientConditionFailure = error => {
  const action = SAVE_PATIENT_CONDITION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_PATIENT_CONDITION_REQUEST  */
/*********************************/
const DELETE_PATIENT_CONDITION_REQUEST = `${
  app.NS
}delete_patientCondition_request`;
export const DELETE_PATIENT_CONDITION_REQUEST_ACTION = createAction(
  DELETE_PATIENT_CONDITION_REQUEST
);
const DELETE_PATIENT_CONDITION_SUCCESS = `${
  app.NS
}delete_patientCondition_success`;

export const DELETE_PATIENT_CONDITION_SUCCESS_ACTION = createAction(
  DELETE_PATIENT_CONDITION_SUCCESS,
  patientCondition => ({
    patientCondition
  })
);
const DELETE_PATIENT_CONDITION_FAILURE = `${
  app.NS
}delete_patientCondition_failure`;
export const DELETE_PATIENT_CONDITION_FAILURE_ACTION = createAction(
  DELETE_PATIENT_CONDITION_FAILURE
);

export const deletePatientConditionRequest = id => {
  const action = DELETE_PATIENT_CONDITION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deletePatientConditionSuccess = user => {
  const action = DELETE_PATIENT_CONDITION_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deletePatientConditionFailure = error => {
  const action = DELETE_PATIENT_CONDITION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};
/*********************************/
/* DELETE_PATIENT_PROGRAM_ITEM_REQUEST  */
/*********************************/
const DELETE_PATIENT_PROGRAM_ITEM_REQUEST = `${NS}delete_patientProgramItem_request`;
export const DELETE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION = createAction(
  DELETE_PATIENT_PROGRAM_ITEM_REQUEST
);
const DELETE_PATIENT_PROGRAM_ITEM_SUCCESS = `${NS}delete_patientProgramItem_success`;

export const DELETE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
  DELETE_PATIENT_PROGRAM_ITEM_SUCCESS,
  patientProgramItem => ({
    patientProgramItem
  })
);
const DELETE_PATIENT_PROGRAM_ITEM_FAILURE = `${NS}delete_patientProgramItem_failure`;
export const DELETE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION = createAction(
  DELETE_PATIENT_PROGRAM_ITEM_FAILURE
);

export const deletePatientProgramItemRequest = id => {
  const action = DELETE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deletePatientProgramItemSuccess = user => {
  const action = DELETE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deletePatientProgramItemFailure = error => {
  const action = DELETE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_PATIENT_PROGRAM_REQUEST  */
/*********************************/
const DELETE_PATIENT_PROGRAM_REQUEST = `${NS}delete_patientProgram_request`;
export const DELETE_PATIENT_PROGRAM_REQUEST_ACTION = createAction(
  DELETE_PATIENT_PROGRAM_REQUEST
);
const DELETE_PATIENT_PROGRAM_SUCCESS = `${NS}delete_patientProgram_success`;

export const DELETE_PATIENT_PROGRAM_SUCCESS_ACTION = createAction(
  DELETE_PATIENT_PROGRAM_SUCCESS,
  patientProgram => ({
    patientProgram
  })
);
const DELETE_PATIENT_PROGRAM_FAILURE = `${NS}delete_patientProgram_failure`;
export const DELETE_PATIENT_PROGRAM_FAILURE_ACTION = createAction(
  DELETE_PATIENT_PROGRAM_FAILURE
);

export const deletePatientProgramRequest = id => {
  const action = DELETE_PATIENT_PROGRAM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deletePatientProgramSuccess = user => {
  const action = DELETE_PATIENT_PROGRAM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deletePatientProgramFailure = error => {
  const action = DELETE_PATIENT_PROGRAM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};
/*********************************/
/* SAVE_PATIENT_PROGRAM_REQUEST  */
/*********************************/
const SAVE_PATIENT_PROGRAM_REQUEST = `${NS}save_patient_program_request`;
export const SAVE_PATIENT_PROGRAM_REQUEST_ACTION = createAction(
  SAVE_PATIENT_PROGRAM_REQUEST
);
const SAVE_PATIENT_PROGRAM_SUCCESS = `${NS}save_patient_program_success`;

export const SAVE_PATIENT_PROGRAM_SUCCESS_ACTION = createAction(
  SAVE_PATIENT_PROGRAM_SUCCESS,
  patientProgram => ({
    patientProgram
  })
);
const SAVE_PATIENT_PROGRAM_FAILURE = `${NS}save_user_failure`;
export const SAVE_PATIENT_PROGRAM_FAILURE_ACTION = createAction(
  SAVE_PATIENT_PROGRAM_FAILURE
);

export const savePatientProgramRequest = id => {
  const action = SAVE_PATIENT_PROGRAM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const savePatientProgramSuccess = user => {
  const action = SAVE_PATIENT_PROGRAM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const savePatientProgramFailure = error => {
  const action = SAVE_PATIENT_PROGRAM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/**************************************/
/* SAVE_PATIENT_PROGRAM_ITEM_REQUEST  */
/**************************************/
const SAVE_PATIENT_PROGRAM_ITEM_REQUEST = `${
  app.NS
}save_patientProgram_item_request`;
export const SAVE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION = createAction(
  SAVE_PATIENT_PROGRAM_ITEM_REQUEST
);
const SAVE_PATIENT_PROGRAM_ITEM_SUCCESS = `${
  app.NS
}save_patientProgram_item_success`;

export const SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
  SAVE_PATIENT_PROGRAM_ITEM_SUCCESS,
  patientProgramItem => ({
    patientProgramItem
  })
);
const SAVE_PATIENT_PROGRAM_ITEM_FAILURE = `${
  app.NS
}save_patientProgram_item_failure`;
export const SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION = createAction(
  SAVE_PATIENT_PROGRAM_ITEM_FAILURE
);

export const savePatientProgramItemRequest = id => {
  const action = SAVE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const savePatientProgramItemSuccess = patientProgramItem => {
  const action = SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION(patientProgramItem);
  action[pendingTask] = end;
  return action;
};
export const savePatientProgramItemFailure = error => {
  const action = SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* INSERT_PATIENT_PROGRAM_ITEM_REQUEST  */
/*********************************/
const INSERT_PATIENT_PROGRAM_ITEM_REQUEST = `${NS}insert_patientProgram_item_request`;
export const INSERT_PATIENT_PROGRAM_ITEM_REQUEST_ACTION = createAction(
  INSERT_PATIENT_PROGRAM_ITEM_REQUEST
);
const INSERT_PATIENT_PROGRAM_ITEM_SUCCESS = `${NS}insert_patientProgram_item_success`;

export const INSERT_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
  INSERT_PATIENT_PROGRAM_ITEM_SUCCESS,
  patientProgramItem => ({
    patientProgramItem
  })
);
const INSERT_PATIENT_PROGRAM_ITEM_FAILURE = `${NS}insert_patientProgram_item_failure`;
export const INSERT_PATIENT_PROGRAM_ITEM_FAILURE_ACTION = createAction(
  INSERT_PATIENT_PROGRAM_ITEM_FAILURE
);

export const insertPatientProgramItemRequest = id => {
  const action = INSERT_PATIENT_PROGRAM_ITEM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const insertPatientProgramItemSuccess = user => {
  const action = INSERT_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const insertPatientProgramItemFailure = error => {
  const action = INSERT_PATIENT_PROGRAM_ITEM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_PATIENT_PROGRAM_REQUEST      */
/*********************************/
const LOAD_PATIENT_PROGRAM_REQUEST = `${NS}load_patient_program_request`;
export const LOAD_PATIENT_PROGRAM_REQUEST_ACTION = createAction(
  LOAD_PATIENT_PROGRAM_REQUEST
);
const LOAD_PATIENT_PROGRAM_SUCCESS = `${NS}load_patient_program_success`;
export const LOAD_PATIENT_PROGRAM_SUCCESS_ACTION = createAction(
  LOAD_PATIENT_PROGRAM_SUCCESS,
  patientProgram => ({
    patientProgram
  })
);
const LOAD_PATIENT_PROGRAM_FAILURE = `${NS}load_patient_program_failure`;
export const LOAD_PATIENT_PROGRAM_FAILURE_ACTION = createAction(
  LOAD_PATIENT_PROGRAM_FAILURE
);

export const loadPatientProgramRequest = id => {
  const action = LOAD_PATIENT_PROGRAM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadPatientProgramSuccess = patientProgram => {
  const action = LOAD_PATIENT_PROGRAM_SUCCESS_ACTION(patientProgram);
  action[pendingTask] = end;
  return action;
};
export const loadPatientProgramFailure = error => {
  const action = LOAD_PATIENT_PROGRAM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LINK_PROGRAM_REQUEST      */
/*********************************/
const LINK_PROGRAM_REQUEST = `${NS}link_program_request`;
export const LINK_PROGRAM_REQUEST_ACTION = createAction(LINK_PROGRAM_REQUEST);
const LINK_PROGRAM_SUCCESS = `${NS}link_program_success`;
export const LINK_PROGRAM_SUCCESS_ACTION = createAction(
  LINK_PROGRAM_SUCCESS,
  programs => ({
    programs
  })
);
const LINK_PROGRAMS_FAILURE = `${NS}load_conditions_failure`;
export const LINK_PROGRAMS_FAILURE_ACTION = createAction(LINK_PROGRAMS_FAILURE);

export const linkProgramRequest = program => {
  const action = LINK_PROGRAM_REQUEST_ACTION(program);
  action[pendingTask] = begin;
  return action;
};
export const linkProgramSuccess = programs => {
  const action = LINK_PROGRAM_SUCCESS_ACTION(programs);
  action[pendingTask] = end;
  return action;
};
export const linkProgramFailure = error => {
  const action = LINK_PROGRAMS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SEND_REMINDER_PATIENT_REQUEST */
/*********************************/
const SEND_REMINDER_PATIENT_REQUEST = `${NS}send_reminder_patient_request`;
export const SEND_REMINDER_PATIENT_REQUEST_ACTION = createAction(
  SEND_REMINDER_PATIENT_REQUEST
);
const SEND_REMINDER_PATIENT_SUCCESS = `${NS}send_reminder_patient_success`;
export const SEND_REMINDER_PATIENT_SUCCESS_ACTION = createAction(
  SEND_REMINDER_PATIENT_SUCCESS,
  patient => ({
    patient
  })
);
const SEND_REMINDER_PATIENT_FAILURE = `${NS}send_reminder_patient_failure`;
export const SEND_REMINDER_PATIENT_FAILURE_ACTION = createAction(
  SEND_REMINDER_PATIENT_FAILURE
);

export const sendReminderPatientRequest = id => {
  const action = SEND_REMINDER_PATIENT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const sendReminderPatientSuccess = patient => {
  const action = SEND_REMINDER_PATIENT_SUCCESS_ACTION(patient);
  action[pendingTask] = end;
  return action;
};
export const sendReminderPatientFailure = error => {
  const action = SEND_REMINDER_PATIENT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SEND_PUSH_NOTIFICATION_REQUEST */
/*********************************/
const SEND_PUSH_NOTIFICATION_REQUEST = `${NS}send_push_notification_request`;
export const SEND_PUSH_NOTIFICATION_REQUEST_ACTION = createAction(
  SEND_PUSH_NOTIFICATION_REQUEST
);
const SEND_PUSH_NOTIFICATION_SUCCESS = `${NS}send_push_notification_success`;
export const SEND_PUSH_NOTIFICATION_SUCCESS_ACTION = createAction(
  SEND_PUSH_NOTIFICATION_SUCCESS,
  patient => ({
    patient
  })
);
const SEND_PUSH_NOTIFICATION_FAILURE = `${NS}send_push_notification_failure`;
export const SEND_PUSH_NOTIFICATION_FAILURE_ACTION = createAction(
  SEND_PUSH_NOTIFICATION_FAILURE
);

export const sendPushNotificationRequest = id => {
  const action = SEND_PUSH_NOTIFICATION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const sendPushNotificationSuccess = patient => {
  const action = SEND_PUSH_NOTIFICATION_SUCCESS_ACTION(patient);
  action[pendingTask] = end;
  return action;
};
export const sendPushNotificationFailure = error => {
  const action = SEND_PUSH_NOTIFICATION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*       INITIALISE STATE        */
/*********************************/
const initialState = {};
export default createReducer(
  {
    [SAVE_PATIENT_SUCCESS_ACTION]: (state, { patients }) => {
      return merge({}, state, merge({}, patients, { loadingPatients: false }));
    },
    [SAVE_PATIENT_CONDITION_SUCCESS_ACTION]: (state, { patientCondition }) => {
      return merge(
        {},
        state,
        merge({}, patientCondition, { loadingPatients: false })
      );
    },

    [SAVE_PATIENT_PROGRAM_SUCCESS_ACTION]: (state, { patientProgram }) => {
      return merge(
        {},
        state,
        merge({}, patientProgram, { loadingPatients: false })
      );
    },
    [LINK_PROGRAM_SUCCESS_ACTION]: (state, { programs }) => {
      return merge({}, state, merge({}, programs, { loadingPatients: false }));
    },

    [LOAD_PATIENT_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingPatient: true });
    },
    [LOAD_PATIENT_SUCCESS_ACTION]: (state, { patient }) => {
      return merge({}, state, merge({}, patient, { loadingPatient: false }));
    },

    [DELETE_SUPPORT_USER_SUCCESS_ACTION]: (state, { supportUser }) => {
      return merge(
        {},
        state,
        merge({}, supportUser, { loadingPatient: false })
      );
    },

    [LOAD_PATIENT_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingPatient: false });
    },

    [DELETE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION]: (
      state,
      { patientProgramItem }
    ) => {
      let newState = Object.assign({}, state);
      delete newState.patientProgramItems[patientProgramItem.id];
      return newState;
    },

    [IMPORT_FORM_REQUEST_ACTION]: state => {
      return merge({}, state, { importing: true });
    },
    [IMPORT_FORM_SUCCESS_ACTION]: (state, { data }) => {
      return merge({}, state, merge({}, data, { importing: false }));
    },
    [IMPORT_FORM_FAILURE_ACTION]: state => {
      return merge({}, state, { importing: false });
    },

    [SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION]: (
      state,
      { patientProgramItem }
    ) => {
      return merge(
        {},
        state,
        merge({}, patientProgramItem, { loadingPrograms: false })
      );
    },

    [DELETE_PATIENT_CONDITION_SUCCESS_ACTION]: (
      state,
      { patientCondition }
    ) => {
      let newState = Object.assign({}, state);
      delete newState.patientConditions[patientCondition.id];
      return newState;
    },
    [DELETE_PATIENT_PROGRAM_SUCCESS_ACTION]: (state, { patientProgram }) => {
      let newState = Object.assign({}, state);
      delete newState.patientPrograms[patientProgram.id];
      return newState;
    },

    [DELETE_GUEST_PERMISSION_SUCCESS_ACTION]: (state, { guestPermission }) => {
      let newState = Object.assign({}, state);
      let patientCondition =
        newState.patientConditions[guestPermission.patientConditionId];
      if (
        patientCondition.relationships &&
        patientCondition.relationships.guestClinicians
      ) {
        delete patientCondition.relationships.guestClinicians.data;
      }
      return newState;
    },

    [LOAD_PATIENT_PROGRAM_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingPrograms: true });
    },
    [LOAD_PATIENT_PROGRAM_SUCCESS_ACTION]: (state, { patientProgram }) => {
      return merge(
        {},
        state,
        merge({}, patientProgram, { loadingPrograms: false })
      );
    },
    [LOAD_PATIENT_PROGRAM_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingPrograms: false });
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/ducks/patient.js